export function ToSearchedContactAddress(_contactAddress: any) {
  const contactAddress = {
    addressSource: _contactAddress.addressSource,
    addressType: _contactAddress.addressType,
    branchCode: _contactAddress.branchCode,
    building: _contactAddress.building,
    contactTemplateBranchId: _contactAddress.contactTemplateBranchId,
    contactTemplateId: _contactAddress.contactTemplateId,
    country: _contactAddress.country,
    district: _contactAddress.district,
    email: _contactAddress.email,
    fax: _contactAddress.fax,
    floorNo: _contactAddress.floorNo,
    homeGroup: _contactAddress.homeGroup,
    homeNo: _contactAddress.homeNo,
    isVat: _contactAddress.isVat,
    merchantType: _contactAddress.merchantType,
    name: _contactAddress.name,
    no: _contactAddress.no,
    personalNamePrefixTypeId: _contactAddress.personalNamePrefixTypeId,
    personalNamePrefixTypeOther: _contactAddress.personalNamePrefixTypeOther,
    phone: _contactAddress.phone,
    postCode: _contactAddress.postCode,
    province: _contactAddress.province,
    road: _contactAddress.road,
    roomNo: _contactAddress.roomNo,
    soi: _contactAddress.soi,
    subDistrict: _contactAddress.subDistrict,
    taxId: _contactAddress.taxId,
    updateDateTime: _contactAddress.updateDateTime,
    website: _contactAddress.website,
    logoUrl: _contactAddress.logoUrl,
  };
  return contactAddress;
}
